import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Product } from '../../shared/classes/productModel';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';
import { UUID } from 'angular2-uuid';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { CognitoService } from 'src/app/shared/services/cognito.service';
import { ProfileService } from 'src/app/shared/services/profile.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.sass']
})
export class ProductComponent implements OnInit {

  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  heading = 'Products';
  subheading = 'fill all the details as per instructions';
  icon = 'pe-7s-wallet icon-gradient bg-plum-plate';
  currentJustify2 = 'justified';
  public loading: boolean;
  pobj: {
    group: string;
    productId: number;
    tradeName: string;
    productuuId: string
    technicalName: string;
    productType: string;
    toxicity: string;
  };
  showList: boolean = true;
  type: string = 'save'
  index: number;
  productDataArray = [];
  collectionSize: number;
  ImageArr = [];
  productForm: FormGroup;
  submitted = false;
  product: Product
  groupName: string;
  btnLoading: boolean = false;
  previousPage: number;
  skip: number;
  page = 1;
  searchStr: string = '';
  showsearchdata: boolean = true;
  constructor(private formBuilder: FormBuilder,
    private profileService: ProfileService,
    private cogService: CognitoService) { }

  ngOnInit() {
    this.cogService.getCurrentUserToken().then((res: any) => {
      this.groupName = res.attributes.family_name;
      this.getAllProducts();
    })
    this.productForm = this.formBuilder.group({
      productId: ['', Validators.required],
      tradeName: ['', Validators.required],
      technicalName: ['', Validators.required],
      productType: ['', Validators.required],
      toxicity: ['', Validators.required],
    });
  }

  loadPage(pageNumber: number) {
    this.loading = true;
    console.log("page number ", pageNumber, this.previousPage)
    if (pageNumber !== this.previousPage) {
      this.skip = (pageNumber * 10) - 10;
      this.previousPage = pageNumber;
      this.loadData(this.skip);
    }
  }

  loadData(skip) {
    this.loading = true;
    this.productDataArray = [];
    var options = {
      group: this.groupName,
      // options: {
      limit: 10,
      // sortFields: { createTs: -1 },
      skip: skip
      // }
    }
    this.profileService.getAllProducts(options).then((data: any) => {
      console.log("getDemandCount : ", data);
      if (data.length > 0) {
        this.productDataArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
    var count = { group: this.groupName }
    this.profileService.getProductCount(count).then((data: any) => {
      console.log("Demand size : ", data)
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  getAllProducts() {
    this.loading = true;
    this.showsearchdata = true;
    this.productDataArray = [];
    var count = { group: this.groupName };
    var options = {
      group: this.groupName,
      // options: {
      limit: 10,
      // sortFields: { createTs: -1 },
      skip: 0
      // }
    }
    this.profileService.getAllProducts(options).then((data: any) => {
      console.log("cropData == ", data);
      if (data.length > 0) {
        this.productDataArray = data;
        this.productDataArray.sort((a, b) => Number(a.productId) - Number(b.productId));
        this.loading = false;
      } else {
        this.loading = false;
      }
    })
    this.profileService.getProductCount(count).then((data: any) => {
      console.log("COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  addForms() {
    this.btnLoading = false;
    this.productForm.reset();
    this.showList = false;
    this.pobj = {
      group: '',
      tradeName: '',
      technicalName: '',
      productType: '',
      productId: null,
      productuuId: '',
      toxicity: '',
    };
    console.log("cobj ", this.pobj);
    this.type = 'save'
  }

  back() {
    this.showList = true;
    this.type = 'back';
    this.getAllProducts();
    this.page = 1;
  }

  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  imageInput(event) {
    console.log("event", event.target.files[0].name)
    if (event.target.files && event.target.files[0]) {
      var fileLength = event.target.files.length
      for (let i = 0; i < fileLength; i++) {
        var reader = new FileReader()
        this.ImageArr.push('prod_' + event.target.files[i].name)
        console.log("ImageArr : ", JSON.stringify(this.ImageArr))

        reader.onload = (event: any) => {
        }
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  saveData() {
    this.loading = true;
    this.btnLoading = true;
    this.pobj.group = this.groupName
    this.pobj.productuuId = UUID.UUID();
    console.log("pobj", JSON.stringify(this.pobj));
    this.product = this.pobj;
    this.profileService.pushProduct(this.product).then((data: any) => {
      console.log("save data result : ", JSON.stringify(data));
      this.btnLoading = false;
      if (data) {
        this.productForm.reset();
        this.showList = true;
        this.productDataArray = [];
        this.page = 1;
        Swal({ title: "Saved successfully" })
        this.getAllProducts();
      } else {
        this.loading = false;
        this.btnLoading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
      }
    })
  }

  editProductData(index) {
    this.showList = false;
    this.index = index;
    console.log("Edited product data", this.productDataArray[index]);
    this.pobj = this.productDataArray[index];
    this.type = 'update'
  }

  updateData() {
    this.loading = true;
    this.btnLoading = true;
    this.pobj.group = this.groupName;
    this.product = this.pobj;
    delete this.product['_id']
    this.profileService.updateProduct(this.product).then((data: any) => {
      console.log(" updateData result : ", JSON.stringify(data));
      this.btnLoading = false;
      if (data) {
        this.productForm.reset();
        this.showList = true;
        this.productDataArray = [];
        this.page = 1;
        Swal({ title: "Updated successfully" })
        this.getAllProducts();
      } else {
        this.loading = false;
        this.btnLoading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
      }
    })
  }

  deleteData(index) {
    this.productDataArray.splice(index, 1)
  }

  searchByName() {
    if (this.searchStr != '') {
      var obj = {
        group: this.groupName,
        field: 'tradeName',
        text: this.searchStr,
        tableName: 'products',
      };
      console.log("search obj : ", obj)
      this.profileService.getProductsRegex(obj).then((data: any) => {
        console.log("searched", data)
        this.searchStr = '';
        this.productDataArray = [];
        if (data.length > 0) {
          this.productDataArray = data;
          this.showsearchdata = false;
          console.log("productDataArray", this.productDataArray);
        }
        else {
          this.showsearchdata = false;
        }
      })
    }
  }
}